<h2 mat-dialog-title>
  {{ isEditMode ? 'Modifier le poste' : 'Nouveau poste' }}
</h2>

<div *ngIf="backendError" class="backend-error-banner">
  <mat-icon>error_outline</mat-icon>
  <span>{{ backendError }}</span>
</div>

<mat-dialog-content class="dialog-content">
  <form [formGroup]="form" class="form">

    <mat-form-field appearance="outline" color="accent" class="full-width">
      <mat-label>Libellé</mat-label>
      <input matInput formControlName="libelle" placeholder="Ex: Développeur Backend" maxlength="120">
      <mat-hint align="end">{{ form.get('libelle')?.value?.length || 0 }}/120</mat-hint>
      <mat-error *ngIf="form.get('libelle')?.hasError('required')">Champ obligatoire</mat-error>
    </mat-form-field>

    <div class="toggle-row" *ngIf="isEditMode">
      <mat-slide-toggle formControlName="active" color="primary">
        Poste actif
      </mat-slide-toggle>
    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()">Annuler</button>
  <button mat-raised-button color="primary"
          type="button"
          (click)="onSubmit()"
          [disabled]="form.invalid || isSubmitting">
    <mat-icon>{{ isEditMode ? 'save' : 'add' }}</mat-icon>
    {{ isEditMode ? 'Modifier' : 'Créer' }}
  </button>
</mat-dialog-actions>
